import React from 'react';
import { func } from 'prop-types';
import classnames from 'classnames';
import { Menu } from '@fiverr-private/orca';
import MenuHeader from './MenuHeader';
import * as Links from './links';

import styles from './styles.module.scss';

import './style.scss';

export const ProfileMenu = ({ close }) => (
    <Menu className={classnames('header-package business-entry avatar-menu pro', styles.container)} close={close}>
        <MenuHeader />
        <Menu.Divider />
        <Links.MenuLocaleSettingsLink ItemWrapper={Menu.Item} />
        <Menu.Divider />
        <Menu.Item>
            <Links.LogoutLink textKey="header.business_visitor.sign_out" />
        </Menu.Item>
        <Menu.Item>
            <Links.ExitBusinessDomainLink />
        </Menu.Item>
    </Menu>
);

ProfileMenu.propTypes = {
    close: func,
};
